import React, { createContext, useContext, useState, useEffect } from "react";

const ReadingContext = createContext();

export function ReadingProvider({ children }) {
  const [readingModeEnabled, setReadingModeEnabled] = useState(() => {
    const saved = localStorage.getItem("readingModeEnabled");
    return saved ? JSON.parse(saved) : false;
  });

  const [speedMultiplier, setSpeedMultiplier] = useState(() => {
    const saved = localStorage.getItem("speedMultiplier");
    return saved ? JSON.parse(saved) : 15;
  });

  useEffect(() => {
    localStorage.setItem(
      "readingModeEnabled",
      JSON.stringify(readingModeEnabled),
    );
  }, [readingModeEnabled]);

  useEffect(() => {
    localStorage.setItem("speedMultiplier", JSON.stringify(speedMultiplier));
  }, [speedMultiplier]);

  const toggleReadingMode = () => {
    setReadingModeEnabled((prev) => !prev);
  };

  const exitReadingMode = () => {
    setReadingModeEnabled(false);
  };

  return (
    <ReadingContext.Provider
      value={{ readingModeEnabled, toggleReadingMode, exitReadingMode, speedMultiplier, setSpeedMultiplier }}
    >
      {children}
    </ReadingContext.Provider>
  );
}

export function useReading() {
  const context = useContext(ReadingContext);
  if (!context) {
    throw new Error("useReading must be used within a ReadingProvider");
  }
  return context;
};
